import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import {
  FDStat,
  Paper,
  PrimaryActionButton,
  Stack,
} from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';

const metaOverrideSet = fr.metaOverride()
  .nameOverride(['amount', 'startDate'], {
    _component: () => FDStat,
  }, {
    ordinal: 200,
  });

export default function AccountFundingInstructionsCard({
  resource,
  onActionClick,
  selected,
}) {
  const { isPageContentLoading } = usePageContentContext();
  const title = resource.attr('title');

  const testSelector = `funding-instructions-${resource.id()}`;

  return (
    <Paper width={'100%'} padding={400}>
      <div test={testSelector}>
        <Stack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
          <Text
            variant={'h4'}
            weight={'medium'}
            align={'left'}
            color={'textPrimary'}
            noWrap
            value={title}
            test={testSelector ? `${testSelector}-title` : undefined}
          />
          <Stack spacing={4} alignItems="flex-start" justifyContent="flex-start">
            <MetaControl
              resource={resource}
              attrName={'amount'}
              metaOverrideSet={metaOverrideSet}
            />
            <MetaControl
              resource={resource}
              attrName={'startDate'}
              metaOverrideSet={metaOverrideSet}
            />
          </Stack>
          <PrimaryActionButton
            isFullWidth
            label={'Get Started'}
            onClick={onActionClick}
            disabled={isPageContentLoading}
            loading={isPageContentLoading && selected}
          />
        </Stack>
      </div>
    </Paper>
  );
}

AccountFundingInstructionsCard.propTypes = {
  resource: PropTypes.object.isRequired,
  onActionClick: PropTypes.func,
  selected: PropTypes.bool,
};

AccountFundingInstructionsCard.defaultProps = {
  onActionClick: noop,
  selected: false,
};
